// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale'
import lang_en from 'element-ui/lib/locale/lang/en'
import lang_cn from 'element-ui/lib/locale/lang/zh-CN'
import 'element-ui/lib/theme-chalk/index.css';
import store from '../src/store/index';
import axios from 'axios'

// 引入VueI18n
import i18n from '../src/axios/i18n';

// 引入echarts
import echarts from 'echarts';


Vue.prototype.$echarts = echarts;
Vue.use(ElementUI);
Vue.config.productionTip = false
// 设置为英文
let lang = '';
if (localStorage.getItem('lang')) {
  lang = localStorage.getItem('lang');
} else {
  lang = navigator.language == 'zh-CN' ? 'zh-cn' : 'en';
}

if (lang == 'zh-cn') {
  locale.use(lang_cn)
} else {
  locale.use(lang_en)
}

localStorage.setItem('lang', lang);


i18n.locale = localStorage.getItem('lang') == 'zh-cn' ? 'zh' : 'en';


/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  store,
  components: {
    App
  },
  template: '<App/>',
  created() {
    axios.get(process.env.VUE_APP_baseURL5 + '/request-api/v1/common/language?type=1')
      .then(res => {
        // 处理响应数据
        console.log(res.data);
        let arr = res.data.msg;
        let objInfo = {
          zh: {
            msg: {},
          },
          en: {
            msg: {},
          },
        };
        arr.forEach((item) => {
          this.$set(objInfo.zh.msg, item.key, item.cn);
          this.$set(objInfo.en.msg, item.key, item.en);
        });
        this.$i18n.setLocaleMessage('zh', objInfo.zh);
        this.$i18n.setLocaleMessage('en', objInfo.en);
        localStorage.setItem('langInfo', localStorage.getItem('lang') == 'zh-cn' ? JSON.stringify(objInfo.zh.msg) : JSON.stringify(objInfo.en.msg))
      })
      .catch(error => {
        // 处理错误情况
        console.error(error);
      });
  }
})



// WEBPACK FOOTER //
// ./src/main.js